import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { KeycloakService } from '@inoventoryapps/keycloak-angular';
import { GeoLevel, UserDetails } from '../models/user.model';
import { LocalStorageService } from '../services/local-storage.service';

export const roleGuard = (roles: string | string[]): CanActivateFn => {
    const rolesToAuthenticate = Array.isArray(roles) ? roles : [roles];
    return () => {
        const keycloakService = inject(KeycloakService);
        const router = inject(Router);
        const hasRole = rolesToAuthenticate.some((role) => keycloakService.isUserInRole(role));

        if (!hasRole) {
            const dashboardUrl = router.parseUrl('/dashboard');
            return new RedirectCommand(dashboardUrl);
        }
        return true;
    };
};

export const geoLevelGuard = (geoLevels: GeoLevel | GeoLevel[]): CanActivateFn => {
    const geoLevelsToCheck = Array.isArray(geoLevels) ? geoLevels : [geoLevels];
    return (route, state) => {
        const keycloakService = inject(KeycloakService);
        const localStorageService = inject(LocalStorageService);
        const router = inject(Router);
        const loggedInUser = localStorageService.get<UserDetails>('userDetails');

        if (!loggedInUser) {
            keycloakService.login({
                redirectUri: window.location.origin + state.url
            });
            return false;
        }

        const { stateId, districtId, blockId } = loggedInUser;
        let resourceName = '';
        switch (loggedInUser.activeGeoLevel) {
            case 'national': {
                resourceName = 'N-00';
                break;
            }
            case 'state': {
                resourceName = `S-${`${stateId}`.padStart(2, '0')}`;
                break;
            }
            case 'district': {
                resourceName = `D-${districtId}`;
                break;
            }
            case 'block': {
                resourceName = `B-${blockId}`;
                break;
            }
            default:
                break;
        }

        const loggedInAsLevel =
            // Verify that currently active geoLevel is one of allowed geoLevels
            geoLevelsToCheck.includes(loggedInUser.activeGeoLevel) &&
            // AND cross check from keycloak server that the logged in user does have the selected role for the logged in geo entity(resource)
            keycloakService.isUserInRole(loggedInUser.activeRoleOgName, resourceName);

        if (!loggedInAsLevel) {
            const dashboardUrl = router.parseUrl('/dashboard');
            return new RedirectCommand(dashboardUrl);
        }
        return true;
    };
};
